import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageTitle, Panel, Table, Field, TextInput, Btn, AddButton, RowActions, EmptyState, Modal } from "../components/ui";
import { useI18n } from "../i18n";
import { useAuth } from "../auth";
import { CL } from "../api";

const empty = { name: "", sector: "", country: "Türkiye", contact_email: "", note: "" };

export default function Clients() {
  const { t } = useI18n();
  const { loadClients } = useAuth();
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const load = () => CL.listClients().then((l) => { setRows(l); loadClients(); }).catch(() => {});
  useEffect(() => { load(); }, []);

  const up = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const openNew = () => { setEditing(null); setForm(empty); setOpen(true); };
  const openEdit = (r) => { setEditing(r); setForm({ ...r }); setOpen(true); };

  const save = async () => {
    if (!form.name.trim()) { toast.error(t("name")); return; }
    try {
      if (editing) await CL.updateClient(editing.id, form);
      else await CL.createClient(form);
      setOpen(false); load(); toast.success(t("saved"));
    } catch { toast.error("Error"); }
  };

  const del = async (r) => {
    if (!window.confirm(t("confirmDelete"))) return;
    await CL.deleteClient(r.id); load(); toast.success("OK");
  };

  return (
    <div data-testid="clients-page">
      <PageTitle title={t("clients")} action={<AddButton label={t("add")} onClick={openNew} />} />
      <Panel>
        {rows.length === 0 ? <EmptyState text={t("noData")} /> : (
          <Table head={[{ label: t("name") }, { label: t("sector") }, { label: t("country") }, { label: t("email") }, { label: t("actions"), right: true }]}>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`client-row-${r.id}`} className="hover:bg-[#fafbf6]">
                <td className="px-4 py-3 font-medium text-[#1b2420]">{r.name}</td>
                <td className="px-4 py-3 text-[#4b544c]">{r.sector || "—"}</td>
                <td className="px-4 py-3 text-[#4b544c]">{r.country}</td>
                <td className="px-4 py-3 text-[#4b544c]">{r.contact_email || "—"}</td>
                <td className="px-4 py-3"><RowActions onEdit={() => openEdit(r)} onDelete={() => del(r)} /></td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>

      <Modal open={open} onClose={() => setOpen(false)} title={editing ? t("edit") : t("add")}
        footer={<><Btn variant="outline" onClick={() => setOpen(false)}>{t("cancel")}</Btn><Btn onClick={save} data-testid="client-save">{t("save")}</Btn></>}>
        <Field label={t("name")}><TextInput data-testid="client-name" value={form.name} onChange={up("name")} /></Field>
        <div className="grid grid-cols-2 gap-4">
          <Field label={t("sector")}><TextInput data-testid="client-sector" value={form.sector} onChange={up("sector")} /></Field>
          <Field label={t("country")}><TextInput data-testid="client-country" value={form.country} onChange={up("country")} /></Field>
        </div>
        <Field label={t("email")}><TextInput data-testid="client-email" value={form.contact_email} onChange={up("contact_email")} /></Field>
        <Field label={t("note")}><TextInput data-testid="client-note" value={form.note} onChange={up("note")} /></Field>
      </Modal>
    </div>
  );
}
